import { render, staticRenderFns } from "./NormalDashboard.vue?vue&type=template&id=6eee5020&scoped=true"
import script from "./NormalDashboard.vue?vue&type=script&lang=js"
export * from "./NormalDashboard.vue?vue&type=script&lang=js"
import style0 from "./NormalDashboard.vue?vue&type=style&index=0&id=6eee5020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eee5020",
  null
  
)

export default component.exports